export default {
    type: 'dom',
    init: function (GG) {
        if (typeof GG.$ !== 'undefined') {
            this.plugin.call(GG);
            GG.log('FormsController plugin loaded.');
        }
        else {
            GG.log('FormsController plugin needs jQuery.');
        }
    },
    plugin: function () {
        var $ = this.$;
        if ($.formsController)
            return false;
        $.formsController = { version: '1.10' };
        var labels = {
            required: 'выделенные поля обязательны для заполнения',
            email: 'введите корректный email',
            phone: {
                min: 0,
                max: 11,
                label: 'введите корректный телефон'
            },
            passwords: 'пароли должны совпадать'
        };
        var methods = {
            init: function (params) {
                return this.each(function () {
                    if (!$(this).data('formsController')) {
                        var options_1 = $.extend({
                            object: $(this),
                            errorsCallback: function ($eContainer, errors) {
                                $eContainer.html(errors.join(', ')).show();
                            },
                            sent: false
                        }, params);
                        options_1.labels = options_1.labels || {};
                        Object.keys(labels).forEach(function (key) {
                            if (!options_1.labels[key]) {
                                options_1.labels[key] = labels[key];
                            }
                        });
                        var $fcEntity_1 = this;
                        $(this)
                            .find('.form__input[type=number]')
                            .on('keydown.fc', function (e) {
                            var min = parseInt($(this).attr('min'), 10);
                            if (min && min > 0) {
                                if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58) || e.keyCode === 8)) {
                                    return false;
                                }
                            }
                        });
                        $(this)
                            .find('.customSelect')
                            .find('select')
                            .on('change.fc', function () {
                            $(this)
                                .closest('.form__label')
                                .removeClass('form__label_error');
                        });
                        $(this)
                            .find('.customSelect')
                            .find('.entry__link')
                            .on('click.fc', function () {
                            $(this)
                                .closest('.form__label')
                                .removeClass('form__label_error');
                        });
                        $(this)
                            .find('.form__input, .field__input, select, textarea')
                            .on('keyup.fc change.fc blur.fc', function (e) {
                            var $field = $(this);
                            if (e.type === 'keyup') {
                                options_1.dirty = true;
                            }
                            if ($field.is('[type=number]')) {
                                var min = parseInt($field.attr('min'), 10), max = parseInt($field.attr('max'), 10), maxlength = parseInt($field.attr('maxlength'), 10), val = $field.val();
                                if (max && val > max) {
                                    $field.val(max);
                                }
                                if (maxlength && val.length > maxlength) {
                                    $field.val(val.slice(0, maxlength));
                                }
                            }
                            if ((e.type === 'blur' || e.type === 'change' || e.type === 'keyup') && options_1.dirty) {
                                $(this)
                                    .closest('.form__label')
                                    .removeClass('form__label_error');
                                methods.check.call($fcEntity_1);
                            }
                        });
                        $(this)
                            .find('.fc-submit')
                            .on('click.fc', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            methods.send.call($fcEntity_1);
                        });
                        if (options_1.submitOnEnter) {
                            $(this)
                                .find('input')
                                .on('keypress.fc', function (e) {
                                if (e.keyCode === 13) {
                                    e.preventDefault();
                                    methods.send.call($fcEntity_1);
                                }
                            });
                        }
                        $(this).data('formsController', options_1);
                    }
                });
            },
            check: function ($fieldsList) {
                var $fields = $fieldsList || $(this).find('input, select, textarea'), $error = $(this).find('.form__error'), message = [], data = $(this).data('formsController');
                if (!data.sent)
                    return false;
                $fields.each(function () {
                    var $field = $(this);
                    if ($field.is('[required]')) {
                        if ($field.is('input') || $field.is('textarea')) {
                            if (!$field.val() || $field.is(':invalid')) {
                                $field.closest('.form__label').addClass('form__label_error');
                                if (!message.length)
                                    message.push(data.labels.required);
                            }
                        }
                        if ($field.is('select') || $field.is(':invalid')) {
                            if (!$field.find('option:checked').val()) {
                                $field.closest('.form__label').addClass('form__label_error');
                                if (!message.length)
                                    message.push(data.labels.required);
                            }
                        }
                    }
                    if ($field.closest('.customSelect').length &&
                        !$field.closest('.customSelect').find('.list__entry_empty').length) {
                        if (!$field.val()) {
                            $field.closest('.form__label').addClass('form__label_error');
                            if (!message.length)
                                message.push(data.labels.required);
                        }
                    }
                });
                $fields.each(function () {
                    var $field = $(this);
                    if ($field.is('[required]')) {
                        if ($field.is('[type=email]') && $field.val()) {
                            if ($field.is(':invalid') ||
                                !/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test($field.val())) {
                                $field.closest('.form__label').addClass('form__label_error');
                                message.push(data.labels.email);
                            }
                        }
                        if ($field.is('.form__input_phone')) {
                            var numbers = $field.val().replace(/\D/g, '');
                            if (numbers.length < data.labels.phone.max) {
                                $field.closest('.form__label').addClass('form__label_error');
                                message.push(data.labels.phone.label);
                            }
                        }
                        if ($field.is('.password') && $fields.filter('.password-confirmation').length) {
                            if ($field.val() != $fields.filter('.password-confirmation').val()) {
                                $fields
                                    .filter('.password')
                                    .closest('.form__label')
                                    .addClass('form__label_error');
                                $fields
                                    .filter('.password-confirmation')
                                    .closest('.form__label')
                                    .addClass('form__label_error');
                                message.push(data.labels.passwords);
                            }
                            else if ($field.val()) {
                                $fields
                                    .filter('.password')
                                    .closest('.form__label')
                                    .removeClass('form__label_error');
                                $fields
                                    .filter('.password-confirmation')
                                    .closest('.form__label')
                                    .removeClass('form__label_error');
                            }
                        }
                        if ($field.is('.custom__input')) {
                            if ($field.is(':invalid')) {
                                $field.closest('label').addClass('chkbox__custom_error');
                            }
                            else {
                                $field.closest('label').removeClass('chkbox__custom_error');
                            }
                        }
                    }
                });
                if (message.length) {
                    if ($fields.filter('[required]').length === 1 && message.length === 2) {
                        message.shift();
                    }
                    data.errorsCallback($error, message);
                    return false;
                }
                else {
                    if (data.dirty) {
                        $error.html('').hide();
                        $fields
                            .closest('label, .form__label')
                            .removeClass('form__label_error')
                            .removeClass('chkbox__custom_error');
                    }
                }
                return true;
            },
            send: function () {
                var data = $(this).data('formsController');
                data.dirty = false;
                data.sent = true;
                if (methods.check.call(this)) {
                    if (typeof data.validationSuccess === 'function') {
                        data.validationSuccess();
                    }
                }
                else {
                    if (typeof data.validationError === 'function') {
                        data.validationError();
                    }
                }
            },
            destroy: function () {
                $(this)
                    .find('.form__input[type=number]')
                    .off('keydown.fc');
                $(this)
                    .find('.form__label')
                    .off('click.fc');
                $(this)
                    .find('.form__input, select')
                    .off('keyup.fc change.fc blur.fc');
                $(this)
                    .find('input')
                    .off('keypress.fc');
                $(this)
                    .find('.customSelect')
                    .find('select')
                    .off('change.fc');
                $(this)
                    .find('.customSelect')
                    .find('.entry__link')
                    .off('click.fc');
                $(this)
                    .find('.fc-submit')
                    .off('click.fc');
                $(this).removeData('formsController');
            }
        };
        $.fn.formsController = function (method) {
            if (methods[method]) {
                return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
            }
            else if (typeof method === 'object' || !method) {
                return methods.init.apply(this, arguments);
            }
            else {
                $.error('Method ' + method + ' does not exist on jQuery.formsController');
            }
        };
    }
};
